// 代理相关API
import httpClient from '../http'
import { API_ENDPOINTS } from '../config'

export const agentsApi = {
  // 获取代理列表
  list: params => httpClient.get(API_ENDPOINTS.AGENTS.LIST, { params }),

  // 创建代理
  create: data => httpClient.post(API_ENDPOINTS.AGENTS.CREATE, data),

  // 更新代理
  update: data => httpClient.put(API_ENDPOINTS.AGENTS.UPDATE, data),

  // 删除代理
  delete: data => httpClient.delete(API_ENDPOINTS.AGENTS.DELETE, { data }),

  // 获取我的卡密
  myCards: params => httpClient.get(API_ENDPOINTS.AGENTS.MY_CARDS, { params }),

  // 获取我的用户列表
  myUsers: params => httpClient.get('/api/agents.html?action=my_users', { params }),

  // 获取代理下的用户列表
  users: params => httpClient.get('/api/agents-simplified.html?action=users', { params }),

  // 获取代理统计数据
  stats: () => httpClient.get('/api/agents-simplified.html?action=stats'),

  // 获取用户增长趋势数据
  getUserGrowthData: () => httpClient.get('/api/agents-simplified.html?action=user-growth-data'),

  // 获取收入统计数据
  getIncomeStats: () => httpClient.get('/api/agents-simplified.html?action=income-stats'),

  // 生成邀请链接
  generateInviteLink: () => httpClient.get('/api/agents-simplified.html?action=invite-link'),

  // 修复邀请码
  fixInviteCodes: () => httpClient.post('/api/agents.html?action=fix_invite_codes'),

  // 获取某个下级用户的金币记录
  userCoinRecords: params => httpClient.get('/api/agents-simplified.html?action=user-coin-records', { params }),

  // 获取启用的应用列表（代理侧）
  apps: () => httpClient.get('/api/agents-simplified.html?action=apps')
  ,
  // 更新下级用户信息（使用正式 agents 接口）
  updateUser: data => httpClient.post('/api/agents.html?action=update_user', data)
}
